'use client'
import { FunnelIcon, CaretDownIcon } from '@phosphor-icons/react'
import { useEffect, useState } from 'react'
import { useStats } from 'react-instantsearch'

import { Button } from '@/components/primitives/Button/Button'

import { CollectionFiltersDrawer } from './CollectionFiltersDrawer'
import { CollectionSortDrawer } from './CollectionSortDrawer'

export function CollectionHeader() {
  const { nbHits } = useStats()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  return (
    <div className="z-10 flex flex-col-reverse items-center justify-between gap-6 text-center text-white sm:flex-row ">
      <div className="text-base font-medium text-gray-900">{mounted && nbHits > 0 ? `${nbHits} Products` : ''}</div>

      {/* Filter and Sort Buttons */}
      <div className="flex justify-center gap-4">
        <CollectionFiltersDrawer>
          <Button variant="outline">
            <FunnelIcon size={16} className="mr-2" />
            Filter
          </Button>
        </CollectionFiltersDrawer>
        <CollectionSortDrawer>
          <Button variant="outline">
            Sort
            <CaretDownIcon size={16} className="ml-2" />
          </Button>
        </CollectionSortDrawer>
      </div>
    </div>
  )
}
